import marketplaceBg from './assets/backgrounds/Registration_Marketplace.jpg';
import oauthBg from './assets/backgrounds/Registration_Oauth.gif';
import teamBg from './assets/backgrounds/Registration_Team.gif';
import background from './assets/backgrounds/background.png';
import amdBackground from './assets/backgrounds/amd-background.png';
import { RegistrationVariantProps } from './interfaces/registrationVariant';

type RegistrationVariantsType = 'primary' | 'marketplace' | 'community' | 'oauth_app' | 'team' | 'amd';

const defaultVariant: RegistrationVariantProps = {
  id: 0,
  type: 'defaultVariant',
  pageLayout: 'fullScreen',
  fullScreenBackground: {
    url: background,
  },
  signUpOptionsForm: {
    title: 'Create your account',
    subtitle: 'Start spending more time on your projects and less time managing your infrastructure.',
  },
};

export const registrationVariants: Record<RegistrationVariantsType, RegistrationVariantProps> = {
  primary: defaultVariant,
  marketplace: {
    ...defaultVariant,
    type: 'marketplace',
    pageLayout: 'fullScreen',
    fullScreenBackground: {
      url: marketplaceBg,
    },
    signUpOptionsForm: {
      title: 'Sign up & deploy – in minutes!',
      subtitle: 'Marketplace solutions let you deploy with a single click!',
    },
    marketplaceAppMetadata: {
      title: 'Your {{registrationFormData.marketplace_app.name}} app is a few steps away',
      description: 'You need to create an account on DigitalOcean',
    },
    termsAndPrivacyFooterColor: 'light',
  },

  community: {
    ...defaultVariant,
    type: 'community',
    pageLayout: 'fullScreen',
    fullScreenBackground: {
      url: background,
    },
    signUpOptionsForm: {
      title: 'Sign up & deploy – in minutes!',
      subtitle:
        'Start learning and growing with DigitalOcean’s community. Creating an account will make it easier to engage with our thousands of free tutorials and other developers in our community. As a bonus, your new account will also give you access to DigitalOcean’s cloud offerings.',
    },
  },

  oauth_app: {
    ...defaultVariant,
    type: 'oauth',
    pageLayout: 'fullScreen',
    fullScreenBackground: {
      url: oauthBg,
    },
    signUpOptionsForm: {
      title: 'Authorization needed',
      subtitle:
        'In order to use {{registrationFormData.oauth_app.name}}, you’ll need to create a DigitalOcean account.',
    },
  },

  team: {
    ...defaultVariant,
    pageLayout: 'fullScreen',
    type: 'team',
    fullScreenBackground: {
      url: teamBg,
    },
    signUpOptionsForm: {
      title: 'Join your team on DigitalOcean!',
      subtitle:
        '{{registrationFormData.team}} has invited you to join them. Sign up and start making waves with your team today!',
    },
    termsAndPrivacyFooterColor: 'light',
  },

  amd: {
    ...defaultVariant,
    type: 'amd',
    pageLayout: 'fullScreen',
    fullScreenBackground: {
      url: amdBackground,
    },
    signUpOptionsForm: {
      title: 'Create your account',
      subtitle: 'Start spending more time on your projects and less time managing your infrastructure.',
    },
    termsAndPrivacyFooterColor: 'light',
    poweredByDigitalOcean: true,
  },
};

// List of active refcodes
export enum Refcodes {
  marketplace = 'marketrefcode',
  glitchPartner = '58a925265b7b',
  lfPartner = '3b1eb93990e5',
  community = 'community',
}
